/**********GridFilters**********/
import HighlightCell from "./HighlightCell";
function containsInsensitive(filter, row) {
   // console.log("trae inf", row.observaciones, "filter",filter)
    if((filter.id === "observaciones" && row.observaciones !== null) || filter.id !== "observaciones" )
    {return (
        row[filter.id] == null ||
        String(row[filter.id])
            .toLowerCase()
            .includes(filter.value.toLowerCase())
    );}
}

function getFiltered(gridState) {
    //console.log("trae 1", gridState);
    return { filtered: gridState.filtered };
}

export default {
    Cell: HighlightCell,
    filterable: true,
    filterMethod: containsInsensitive,
    getProps: getFiltered
};